// Folliq cap page v10 extras (cart, gallery, tabs and sticky live in fq-cap-mg.js). Plain module, no dependencies.
const root = document.querySelector('.fb[data-fm]');
if (root) {
  /* ---------- video tiles open one shared dialog ---------- */
  const dlg = root.querySelector('[data-fb-dialog]');
  const vid = dlg ? dlg.querySelector('video') : null;
  if (dlg && vid) {
    const stop = () => { vid.pause(); vid.removeAttribute('src'); vid.load(); };
    root.querySelectorAll('[data-fb-video]').forEach((b) => b.addEventListener('click', () => {
      vid.src = b.dataset.fbVideo;
      if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
      vid.play().catch(() => {});
    }));
    dlg.querySelector('[data-fb-dialog-close]')?.addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('close', stop);
  }

  /* ---------- gallery slides 2+: fetch only after the hero image has loaded, or on first gallery interaction ---------- */
  const deferred = [...root.querySelectorAll('img[data-srcset]')];
  if (deferred.length) {
    const hydrate = () => { root.querySelectorAll('source[data-srcset]').forEach((so) => { so.srcset = so.dataset.srcset; so.sizes = so.dataset.sizes; so.removeAttribute('data-srcset'); }); deferred.splice(0).forEach((im) => { im.srcset = im.dataset.srcset; im.sizes = im.dataset.sizes; im.src = im.dataset.src; im.removeAttribute('fetchpriority'); }); };
    const gal = root.querySelector('[data-fm-gal]');
    const hero = gal ? gal.querySelector('img') : null;
    const later = () => setTimeout(hydrate, 400);
    if (hero && !hero.complete) hero.addEventListener('load', later, { once: true }); else later();
    if (gal) ['pointerdown', 'touchstart', 'keydown', 'focusin'].forEach((ev) => gal.addEventListener(ev, hydrate, { once: true, passive: true }));
    const tr = gal ? gal.querySelector('[data-fm-track]') : null;
    if (tr) tr.addEventListener('scroll', hydrate, { once: true, passive: true });
  }

  /* ---------- choosing a set shows that set's own image (variant featured media) ---------- */
  const slidesById = new Map([...root.querySelectorAll('[data-fm-slide][data-media-id]')].map((sl, i) => [sl.dataset.mediaId, i]));
  root.querySelectorAll('input[name="id"][data-media]').forEach((inp) => inp.addEventListener('change', () => {
    const i = slidesById.get(inp.dataset.media);
    if (i === undefined) return;
    root.querySelectorAll('source[data-srcset]').forEach((so) => { so.srcset = so.dataset.srcset; so.sizes = so.dataset.sizes; so.removeAttribute('data-srcset'); }); root.querySelectorAll('img[data-srcset]').forEach((im) => { im.srcset = im.dataset.srcset; im.sizes = im.dataset.sizes; im.src = im.dataset.src; im.removeAttribute('data-srcset'); });
    root.querySelector(`[data-fm-thumb="${i}"]`)?.click();
  }));

  /* ---------- FAQ: show the rest on request ---------- */
  root.querySelectorAll('[data-fb-faqs-all]').forEach((btn) => btn.addEventListener('click', () => {
    root.querySelectorAll('.fb-faq--more').forEach((d) => d.classList.remove('fb-faq--more'));
    btn.parentElement.remove();
  }));

  /* ---------- review photos: thumb opens a zoom dialog, arrows / keys move within that review ---------- */
  const zd = root.querySelector('[data-fb-zoom-dlg]');
  if (zd) {
    const zi = zd.querySelector('[data-fb-zoom-img]'), zc = zd.querySelector('[data-fb-zoom-count]');
    const zp = zd.querySelector('[data-fb-zoom-prev]'), zn = zd.querySelector('[data-fb-zoom-next]');
    let set = [], at = 0;
    const show = (i) => {
      at = (i + set.length) % set.length;
      zi.src = set[at];
      const many = set.length > 1;
      zp.hidden = zn.hidden = zc.hidden = !many;
      zc.textContent = many ? `${at + 1} / ${set.length}` : '';
    };
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-fb-zoom]');
      if (!b) return;
      const g = b.closest('[data-fb-zoom-group]');
      const btns = g ? [...g.querySelectorAll('[data-fb-zoom]')] : [b];
      set = btns.map((x) => x.dataset.fbZoom);
      show(btns.indexOf(b));
      if (typeof zd.showModal === 'function') zd.showModal(); else zd.setAttribute('open', '');
    });
    zp.addEventListener('click', () => show(at - 1));
    zn.addEventListener('click', () => show(at + 1));
    zd.addEventListener('keydown', (e) => { if (set.length > 1 && e.key === 'ArrowLeft') show(at - 1); if (set.length > 1 && e.key === 'ArrowRight') show(at + 1); });
    zd.querySelector('[data-fb-zoom-close]').addEventListener('click', () => zd.close());
    zd.addEventListener('click', (e) => { if (e.target === zd) zd.close(); });
    zd.addEventListener('close', () => { zi.removeAttribute('src'); });
  }

  /* ---------- "You may also like": progress bar follows the horizontal scroll ---------- */
  root.querySelectorAll('[data-fb-scroller]').forEach((sc) => {
    const bar = sc.parentElement.querySelector('[data-fb-scrollbar]');
    if (!bar) return;
    const paint = () => {
      const max = sc.scrollWidth - sc.clientWidth;
      const seen = sc.scrollWidth ? (sc.scrollLeft + sc.clientWidth) / sc.scrollWidth : 1;
      bar.style.width = Math.min(100, Math.max(8, seen * 100)) + '%';
      bar.parentElement.hidden = max <= 4;
    };
    let raf = 0;
    sc.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); }, { passive: true });
    addEventListener('resize', paint);
    paint();
  });
  /* ---------- entrance reveal for [data-fb-rv] (skipped with reduced motion) ---------- */
  const rv = [...root.querySelectorAll('[data-fb-rv]')];
  if (rv.length && 'IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
    root.classList.add('js-rv');
    const io = new IntersectionObserver((ens) => ens.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-shown'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    rv.forEach((el) => io.observe(el));
  }

  /* ---------- customer results: arrows scroll one card, hidden when there is nothing to scroll ---------- */
  root.querySelectorAll('[data-fb-car]').forEach((car) => {
    const tr = car.querySelector('[data-fb-car-track]');
    const prev = car.querySelector('[data-fb-car-prev]'), next = car.querySelector('[data-fb-car-next]');
    if (!tr || !prev || !next) return;
    const step = () => { const c = tr.firstElementChild; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(tr).columnGap || 0) : tr.clientWidth; };
    const paint = () => { const max = tr.scrollWidth - tr.clientWidth; prev.hidden = tr.scrollLeft <= 4; next.hidden = tr.scrollLeft >= max - 4; };
    prev.addEventListener('click', () => tr.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => tr.scrollBy({ left: step(), behavior: 'smooth' }));
    let raf = 0;
    tr.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); }, { passive: true });
    addEventListener('resize', paint);
    paint();
  });
}
/* Delivery estimate (2026-10-07): "{dates}" -> "Mon, Oct 12 – Tue, Oct 13", counting business days from today. */
(() => {
  const el = document.querySelector('[data-fm-eta]');
  if (!el) return;
  const [a, b] = el.dataset.fmEta.split(',').map(Number);
  const add = (n) => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) k++; } return d; };
  const loc = document.documentElement.lang || 'en-US';
  const f = (d) => d.toLocaleDateString(loc, { weekday: 'short', month: 'short', day: 'numeric' });
  const span = el.querySelector('[data-tpl]');
  if (span && a && b) span.textContent = span.dataset.tpl.replace('{dates}', `${f(add(a))} – ${f(add(b))}`);
})();

/* Launch offer (2026-10-07): apply the code to the session so checkout shows the discount without typing it. */
(() => {
  const el = document.querySelector('[data-fm-launch]');
  const code = el && el.dataset.fmLaunch;
  if (!code) return;
  try { fetch(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(location.pathname)}`, { credentials: 'same-origin', redirect: 'manual' }).catch(() => {}); } catch (e) {}
})();

/* How it works (2026-10-07): highlight step 1 -> 2 -> 3 in the image and the list while the section is on screen.
   Hover or focus on a step pins it. Reduced motion: no cycling, everything stays visible. */
(() => {
  const fig = document.querySelector('[data-fm-how]');
  if (!fig) return;
  const sec = fig.closest('section');
  const steps = [...sec.querySelectorAll('[data-fm-how-step]')];
  const set = (n) => { fig.dataset.on = n; steps.forEach((s) => s.classList.toggle('is-on', +s.dataset.fmHowStep === n)); };
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let n = 1, timer = null, pinned = false;
  const run = () => { if (!timer) { set(n); timer = setInterval(() => { if (!pinned) { n = n % 3 + 1; set(n); } }, 3200); } };
  const stop = () => { clearInterval(timer); timer = null; };
  steps.forEach((s) => {
    const pin = () => { pinned = true; n = +s.dataset.fmHowStep; set(n); };
    s.addEventListener('mouseenter', pin); s.addEventListener('focusin', pin);
    s.addEventListener('mouseleave', () => { pinned = false; }); s.addEventListener('focusout', () => { pinned = false; });
    s.tabIndex = 0;
  });
  if ('IntersectionObserver' in window) new IntersectionObserver(([e]) => { e.isIntersecting ? run() : stop(); }, { threshold: 0.35 }).observe(sec);
  else run();
})();
